import * as React from 'react';
import { InformationChange } from './InformationChange';
import { BalanceChange } from './BalanceChange';

const PostRegEditsReview = () => (
  <div
    data-testid="PostRegEditsReview-content"
    className="sui-flex sui-flex-col sui-gap-2 sui-w-full"
  >
    <p>Summary of the changes will be emailed to the registrant.</p>
    <div className="sui-flex sui-flex-col sui-gap-4">
      <InformationChange />
      <BalanceChange />
    </div>
  </div>
);

export default PostRegEditsReview;
